import { createFileRoute, redirect } from '@tanstack/react-router';
import { meQueryOptions } from '~/api/auth';
import { Landing } from '~/features/landing/Landing';

/**
 * 11deeds.com itself: signed in, straight to the dashboard; otherwise the landing page
 * that says what 11Deeds is, with Sign in and Get started.
 */
export const Route = createFileRoute('/')({
  beforeLoad: async ({ context }) => {
    const me = await context.queryClient.fetchQuery(meQueryOptions).catch(() => null);
    if (me) throw redirect({ to: me.person.role === 'guest' ? '/orders' : '/dashboard' });
  },
  component: Landing,
});
